import React, { useContext } from 'react';
import useT from '../../../utils/Translations/useT';
import { PanelButton, PanelButtonDivider } from '../../PanelButtons';
import { FilterHidingContext } from './FilterHidingContext';
export const FilterHidingContextButton = ({ hasDivider = false, buttonAlign = 'left', }) => {
    const t = useT();
    const { toggleVisible, hasFilterBar } = useContext(FilterHidingContext);
    if (!hasFilterBar) {
        return null;
    }
    return (<>
      {hasDivider && buttonAlign === 'right' ? <PanelButtonDivider /> : null}
      <PanelButton icon="equalizer" title={t('Toggle Filters')} onClick={toggleVisible}/>
      {hasDivider && buttonAlign === 'left' ? <PanelButtonDivider /> : null}
    </>);
};
